import { useState } from 'react';
import { Form, Progress, Table } from 'reactstrap';
import HttpStatus from 'http-status-codes';
import { getTask, uploadOrders } from '../../api';

function wait(interval) {
	return new Promise(resolve => setTimeout(resolve, interval));
}

async function runTask(id, setTask) {
	let running = true;
	const delay = 500;
	while(running) {
		await wait(delay);
		try {
			const res = await getTask(id);
			if(res.status === HttpStatus.ACCEPTED) {
				const done = res.data?.done;
				if(typeof done === 'number') {
					setTask(prev => ({ ...prev, done, total: res.data.total }));
				}
			} else {
				running = false;
				setTask({ results: res.data.results });
			}
		} catch(err) {
			running = false;
			if(err.response?.data?.error) {
				const { error } = err.response.data;
				window.alert(error);
			} else {
				window.alert(err.message);
			}
			setTask(null);
		}
	}
}

export default function OrderImportPage() {
	const [submitting, setSubmitting] = useState(false);
	const [file, setFile] = useState();
	const [task, setTask] = useState();
	return <section>
		<Form className="container" onSubmit={async e => {
			e.preventDefault();
			if(!file) {
				return;
			}
			try {
				setSubmitting(true);
				setTask(null);
				const response = await uploadOrders(file);
				await runTask(response.task, setTask);
			} catch(err) {
				if(err.response?.data?.message) {
					const { error, message } = err.response.data;
					window.alert(`${message}: ${error}`);
				} else {
					window.alert(err.message);
				}
			} finally {
				setSubmitting(false);
			}
		}}>
			<p>Upload een csv met de kolommen <code>pickDate;orderNo;lineId;wmsComment;shipmentNo;paymentTermsCode</code>.</p>
			<p>
				<input type="file" accept=".csv,text/csv" onChange={e => {
					setFile(e.target.files?.[0]);
				}} />
			</p>
			<p>
				<input type="submit" className="btn btn-primary" value="Upload" disabled={submitting || !file} />
			</p>
			{typeof task?.done === 'number' && <p>
				<Progress value={task.done} max={task.total} animated />
			</p>}
			{task?.results?.length ? <Table>
				<thead>
					<tr>
						<th>orderNo</th>
						<th>shipmentNo</th>
						<th>result</th>
					</tr>
				</thead>
				<tbody>
					{task.results.map((result, i) => {
						return <tr key={i}>
							<td>{result.orderNo}</td>
							<td>{result.shipmentNo}</td>
							<td>{result.result}</td>
						</tr>;
					})}
				</tbody>
			</Table> : null}
		</Form>
	</section>;
}
